/** @typedef {'US' | 'GB' | 'CA' | 'ES' | 'AU'} MarketCode */

const INVOICE_IMAGE_BASE = '/static/images/invoices'

/** @type {Record<MarketCode, string>} */
const EXAMPLE_INVOICE_IMAGE_FILE_BY_MARKET = {
  US: 'example-invoice-us.png',
  GB: 'example-invoice-uk.png',
  CA: 'example-invoice-ca.png',
  ES: 'example-invoice-es.png',
  AU: 'example-invoice-au.png',
}

export const DEFAULT_EXAMPLE_INVOICE_IMAGE_URL = `${INVOICE_IMAGE_BASE}/example-invoice-us.png`

/**
 * Public URL for pre-rendered static pages and build scripts.
 * @param {MarketCode | null | undefined} marketCode
 * @returns {string}
 */
export function getExampleInvoiceImageUrl(marketCode) {
  const filename =
    marketCode && EXAMPLE_INVOICE_IMAGE_FILE_BY_MARKET[marketCode]
      ? EXAMPLE_INVOICE_IMAGE_FILE_BY_MARKET[marketCode]
      : 'example-invoice-us.png'
  return `${INVOICE_IMAGE_BASE}/${filename}`
}

/** @type {Record<string, string>} */
export const EXAMPLE_INVOICE_IMAGE_URLS = {
  default: DEFAULT_EXAMPLE_INVOICE_IMAGE_URL,
  US: getExampleInvoiceImageUrl('US'),
  GB: getExampleInvoiceImageUrl('GB'),
  CA: getExampleInvoiceImageUrl('CA'),
  ES: getExampleInvoiceImageUrl('ES'),
  AU: getExampleInvoiceImageUrl('AU'),
}
